module.exports = __webpack_public_path__ + "img/TAC6000&TAM4000.e83eb3c1.png";